import React from "react";
import styled from "@emotion/styled";

import { MainSection } from "./MainSection";
import { ShowoffSection } from "./ShowoffSection";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
`;

export const Home: React.FC = (props) => {
  return (
    <Container>
      <MainSection />
      <ShowoffSection />
    </Container>
  );
};
